
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"160","height":"160","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('mask',{staticStyle:{"mask-type":"luminance"},attrs:{"id":"secure_payments_svg__a","maskUnits":"userSpaceOnUse","x":"82","y":"18","width":"59","height":"128"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M82.256 18.937H141v126.619H82.256V18.936z","fill":"#fff"}})]),_c('g',{attrs:{"mask":"url(#secure_payments_svg__a)"}},[_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M139.567 37.916c-35.885-1.036-57.31-18.98-57.31-18.98v15.452s16.196 13.564 43.323 14.347c0 0 11.912 62.327-43.324 81.369v15.452c73.07-25.19 57.311-107.64 57.311-107.64","fill":"#FFD250"}})]),_c('path',{attrs:{"d":"M80.239 13.493s21.939 18.633 58.683 19.707c0 0 16.136 85.619-58.683 111.777M80.239 13.493S58.299 32.126 21.555 33.2c0 0-16.136 85.619 58.684 111.777","stroke":"#000"}}),_c('path',{attrs:{"d":"M80.239 29.924s16.457 13.978 44.021 14.784c0 0 12.104 64.227-44.021 83.849M80.239 29.924S63.78 43.902 36.218 44.708c0 0-12.105 64.227 44.02 83.849","stroke":"#000"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M57.427 84.425l20.854 16.502 7.945-9.172L65.37 75.252l-7.943 9.173z","fill":"#5CE8AD"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M100.377 57.542l-31.375 35.45 9.221 7.903 31.375-35.452-9.221-7.9z","fill":"#5CE8AD"}})])
          )
        }
      }
    